var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "capusta_info-content"
  }, [_c('h4', {
    staticClass: "capusta_info-content-title"
  }, [_vm._v("Как это работает?")]), _c('p', [_vm._v(" После успешной оплаты счета вместо обычной страницы с квитанцией плательщику откроется содержимое твоей ссылки или встроенный код. Это может быть файл в облачном хранилище, iframe видео с Youtube или доступ к секретному чату. Да что угодно! ")]), _c('p', [_vm._v(" Мы не ограничиваем возможности вставки ссылок, но некоторые ресурсы могут накладывать ограничения на демонстрацию их содержимого. ")]), _c('p', [_vm._v(" Ссылка на страницу успешной оплаты автоматически отправляется плательщику на email. Так за ним сохранится возможность доступа к оплаченному контенту при случайном закрытии браузера. Просмотреть его снова сможет только сам плательщик. ")]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }